import React, { useState, useEffect, useReducer } from "react";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  SwipeableDrawer,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Switch,
  Backdrop,
  CircularProgress,
  DialogContent,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import { toast } from "react-toastify";
import ViewIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useNotification } from "../../../hooks/useNotification.js";
import { IoIosShareAlt } from "react-icons/io";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

export default function ViewJobposting() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");

  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [internalJob, setInternalJob] = useState({});
  const [jobpostingData, setJobpostingData] = useState([]);
  const [confimationOpen, setConfimationOpen] = useState(false);
  const [requirementId, setRequirementId] = useState("");
  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [candidateReferModal, setCandidateReferModal] = useState(false);

  function isValidFileType(fileName, allowedFileTypes) {
    if (!fileName) {
      return false; // Return false if fileName is undefined or null
    }
    if (fileName) {
      const fileExtension = fileName.split(".").pop().toLowerCase();
      return allowedFileTypes.includes(fileExtension);
    }
  }

  const validationSchema = Yup.object().shape({
    requirementId: Yup.string().required("Requirement Id is required"),

    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    skills: Yup.string().required("Skill is required"),
    resume: Yup.mixed()
      .required("Resume file required")
      .test(
        "is-valid-type",
        "Not a valid File type",
        (value) =>
          value &&
          isValidFileType(value.name.toLowerCase(), ["pdf", "doc", "docx"]),
      )
      .test(
        "is-valid-size",
        "Max allowed size is 25mb",
        (value) => value && value.size <= 25000000,
      ),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const HeaderElements = () => <>Total : {count}</>;

  const handleCandidateReferModalOpen = (id) => {
    setCandidateReferModal(true);
    setValue("requirementId", id);
  };
  const handleCandidateReferModalClose = () => {
    setCandidateReferModal(false);
    reset();
  };

  const handleConfirmationModalOpen = (id) => {
    setRequirementId(id);
    setConfimationOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
    setRequirementId("");
  };

  const handleChangeResumeFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("resume", file);
    }
  };

  useEffect(() => {
    fetchData();
  }, [token]);

  const handleAddCandidate = async (values) => {
    try {
      setLoader(true);
      const formData = new FormData();

      formData.append("resume", values.resume);
      formData.append("requirementId", values.requirementId);
      formData.append("firstName", values.firstName);
      formData.append("lastName", values.lastName);
      formData.append("email", values.email);
      formData.append("mobile", values.mobile);
      formData.append("skills", values.skills);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/referACandidate`,
        {
          ...values,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchData();
        handleCandidateReferModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchData = async () => {
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/getInternalRequirements?page=${currentPage}`,

      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);

        setJobpostingData(response.data.data);
        setCount(response.data.count);
      }
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentPage(newPage + 1);
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/getInternalRequirements?page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setJobpostingData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    });
  };

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const handleSayInterest = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}employee/showInterstToRequirement`,
        data: {
          requirementId: requirementId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          handleNotificationCall("success", response.data.message);
          fetchData();
        } else {
          handleNotificationCall("error", response.data.message);
        }
        setLoader(false);
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const ViewJobposting = async (req_id) => {
    setLoader(true);
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}employee/getOneInternalRequirement`,
        data: {
          id: req_id,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.data.status === true) {
        const internalData = response.data.data;
        setInternalJob(internalData); // Update state
        console.log(internalData); // Correctly logs the new data
        toggleDrawer("right", true)();
      } else {
        console.error("API returned false status:", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false); // Stop loader
    }
  };

  const list = (anchor) => (
    <Box sx={{ width: "100%" }} role="presentation">
      <List>
        <Card className={classes.root}>
          <CardHeader>
            <Grid
              container
              direction="row"
              spacing={1}
              className={classes.drawerHeader}
            >
              <Typography variant="subtitle1"> View Requirement</Typography>

              <Grid className={classes.drawerClose}>
                <CloseIcon
                  className={classes.closeBtn}
                  size="14px"
                  onClick={toggleDrawer(anchor, false)}
                />
              </Grid>
            </Grid>
          </CardHeader>

          <CardContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Name:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.requirementName +
                  " (" +
                  internalJob?.uniqueId +
                  ")"}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Experience:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {internalJob?.experience}
                </Grid>
                {/* {jobPostingView.isActive === true ? (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.green + " " + classes.noPointer}
                    >
                      ACTIVE
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.red + " " + classes.noPointer}
                    >
                      INACTIVE
                    </Button>
                  </>
                )} */}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>Skills:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.skills}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>Location:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.jobLocation}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Mode of work:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.modeOfWork}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Special hiring:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.specialHiring}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>JD:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.requirementJd}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Gist:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div
                  dangerouslySetInnerHTML={{ __html: internalJob?.gist }}
                ></div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Posted Date:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {moment(internalJob?.createdAt).format("DD-MM-YYYY")}
              </Grid>
            </Grid>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
                width={100}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </CardContent>
        </Card>
      </List>
    </Box>
  );

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Internal Jobs" />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Requirement Name",
              },
              {
                name: "Hiring Name",
              },
              {
                name: "Experience",
              },
              {
                name: "Skills",
              },
              {
                name: "Location",
              },
              {
                name: "Posted Date",
              },
              {
                name: "Action",
              },
              {
                name: "",
              },
            ]}
            data={jobpostingData.map((item, index) => {
              return [
                <>
                  {currentPage !== 0
                    ? 10 * currentPage - 10 + index + 1
                    : index + 1}
                </>,
                <>{item.requirementName + " (" + item.uniqueId + ")"}</>,

                <>
                  {item.client.handler.firstName +
                    " " +
                    item.client.handler.lastName}
                </>,

                item.experience,
                item.skills,
                item.jobLocation,
                moment(item.createdAt).format("DD-MM-YYYY"),
                <>
                  <Grid container className={classes.space}>
                    <Grid item xs className={classes.toolAlign}>
                      <Tooltip
                        title="View Job Requirement"
                        placement="bottom"
                        aria-label="view"
                      >
                        <ViewIcon
                          className={classes.toolIcon}
                          onClick={() => ViewJobposting(item.id)}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </>,
                <div
                  className={classes.center}
                  style={{
                    justifyContent: "start",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.purple}
                    onClick={() => handleConfirmationModalOpen(item.id)}
                  >
                    I'm interested
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    className={classes.orange}
                    style={{ color: "#000000" }}
                    endIcon={<IoIosShareAlt />}
                    onClick={() => handleCandidateReferModalOpen(item.id)}
                  >
                    Refer
                  </Button>
                </div>,
              ];
            })}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
        <SwipeableDrawer
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
          classes={{ paper: classes.drawer }}
        >
          {list("right")}
        </SwipeableDrawer>
      </Grid>

      <Dialog
        onClose={handleConfirmationModalClose}
        aria-labelledby="dialog-title"
        open={confimationOpen}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Confirmation
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleConfirmationModalClose}
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <Typography variant="subtitle2" style={{ textAlign: "left" }}>
            Do you wish to proceed with the application of this requirement?
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSayInterest}
            >
              Yes
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleConfirmationModalClose}
            >
              No
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth="xs"
        open={candidateReferModal}
        onClose={handleCandidateReferModalClose}
      >
        <DialogContent style={{ padding: "20px 14px" }}>
          <form onSubmit={handleSubmit(handleAddCandidate)}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <p style={{ fontSize: "18px", fontWeight: 600, margin: 0 }}>
                    Candidate Details
                  </p>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="firstName">
                      First Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter First Name"
                        id="firstName"
                        name="firstName"
                        {...register("firstName")}
                        error={errors.firstName ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.firstName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="lastName">
                      Last Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Last Name"
                        id="lastName"
                        name="lastName"
                        {...register("lastName")}
                        error={errors.lastName ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.lastName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="email">
                      Email
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        placeholder="Enter Email Id"
                        id="email"
                        name="email"
                        {...register("email")}
                        error={errors.email ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.email?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="mobile">
                      Contact Number
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        size="small"
                        type="number"
                        placeholder="Enter Mobile Number"
                        id="mobile"
                        name="mobile"
                        {...register("mobile")}
                        error={errors.mobile ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.mobile?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="skills">
                      Skills
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        InputProps={{ disableUnderline: true }}
                        placeholder="Enter Candidate Skills"
                        name="skills"
                        {...register("skills")}
                        error={errors.skills ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.skills?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel shrink htmlFor="resume">
                      Resume
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        type="file"
                        classes={{ root: classes.customTextField }}
                        InputProps={{
                          disableUnderline: true,
                          accept:
                            ".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                        }}
                        placeholder="Enter Candidate Resume"
                        name="resume"
                        onChange={handleChangeResumeFile}
                        error={errors.resume ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.resume?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={isSubmitting}
                      style={{ flex: 1, width: "100%" }}
                      type="submit"
                    >
                      Save
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleCandidateReferModalClose()}
                      style={{ flex: 1, width: "100%" }}
                    >
                      cancel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
